import { ReactNode, SVGProps } from "react";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import styles from "./ListItem.module.css";

type ListItemProps = {
  title: string;
  onClick: () => void;
  disabled?: boolean | undefined;
  addOn?: ReactNode | undefined;
  description?: string | undefined;
  icon?: ((prefix?: string) => SVGProps<SVGElement>[]) | undefined;
  emphasised: boolean;
};

function ListItem({
  onClick,
  title,
  disabled,
  addOn,
  description,
  icon,
  emphasised,
}: ListItemProps) {
  return (
    <FixaListViewItem
      type="button"
      control="navigational"
      controlIcon={null}
      onClick={onClick}
      emphasised={emphasised}
      inset
      disabled={!!disabled}
      title={title}
      description={description}
      addOn={addOn}
      leadingIcon={icon}
      className={styles["listItem"]}
    />
  );
}

export default ListItem;
